import { useState } from 'react';

import { useHistory } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app';
import { logout, selectAppDevice, selectAppState, selectAuth } from 'slice';
import { DEVICES, handleRedirectSignIn } from 'utils';

import ErrorDomainNotFoundDesktop from './ErrorDomainNotFoundDesktop';
import ErrorDomainNotFoundMobile from './ErrorDomainNotFoundMobile';

type ErrorDomainProps = {
  error?: string;
  statusCode?: number;
};

const ErrorDomainNotFound = ({ error, statusCode }: ErrorDomainProps) => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const appDevice = useAppSelector(selectAppDevice);
  const app = useAppSelector(selectAppState);
  const auth = useAppSelector(selectAuth);

  const onSignIn = async () => {
    setIsLoading(true);
    try {
      if (!auth.isLogout) {
        await dispatch(logout()).unwrap();
      }

      handleRedirectSignIn(
        history,
        '/sign-in',
        appDevice.isSpecificBrowser,
        app?.domains?.hubIdentity?.domain
      );
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.log('An error occurred while logging out', err);
    } finally {
      setIsLoading(false);
    }
  };

  const onSignUp = async () => {
    setIsLoading(true);
    try {
      if (!auth.isLogout) {
        await dispatch(logout()).unwrap();
      }

      handleRedirectSignIn(
        history,
        '/sign-in',
        appDevice.isSpecificBrowser,
        app?.domains?.hubIdentity?.domain
      );
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.log('An error occurred while logging out', err);
    } finally {
      setIsLoading(false);
    }
  };

  const onContact = async () => {
    window.open('https://hubtech.asia', '_blank', 'noopener,noreferrer');
  };

  const formatProps = () => {
    return {
      error,
      onSignIn,
      onSignUp,
      onContact,
      isLoading,
      statusCode,
    };
  };

  const renderElements = {
    [DEVICES.DESKTOP]: <ErrorDomainNotFoundDesktop {...formatProps()} />,
    [DEVICES.TABLET]: <ErrorDomainNotFoundMobile {...formatProps()} />,
    [DEVICES.MOBILE]: <ErrorDomainNotFoundMobile {...formatProps()} />,
  };

  return renderElements[appDevice.device];
};

export default ErrorDomainNotFound;
